import { render, staticRenderFns } from "./ProfileBody.vue?vue&type=template&id=78f43936&scoped=true"
import script from "./ProfileBody.vue?vue&type=script&lang=js"
export * from "./ProfileBody.vue?vue&type=script&lang=js"
import style0 from "./ProfileBody.vue?vue&type=style&index=0&id=78f43936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f43936",
  null
  
)

export default component.exports